export default __webpack_public_path__ + "images/Neotrata_logo.png";